import { Check } from "lucide-react";
import { MediaImage } from "../MediaImage";
import { useSiteMedia } from "../../lib/siteMedia";
import { SectionHeading } from "../home/CtaButtons";

export const ProductOptions = ({ options }) => {
  const media = useSiteMedia();
  return (
    <section id="uitvoeringen" aria-labelledby="uitvoeringen-title" className="section scroll-mt-12 border-y border-slate-200 bg-slate-50" data-testid="product-options">
      <div className="container-tight">
        <SectionHeading id="uitvoeringen-title" eyebrow="Uitvoeringen" title={options.title} lead={options.lead} />
        <div className="mt-10 grid gap-6 lg:grid-cols-12">
          <div className="frame lg:col-span-5 lg:self-start">
            <MediaImage media={media(options.media)} sizes="(min-width: 1024px) 480px, calc(100vw - 32px)" className="aspect-[4/3] rounded-[14px] lg:aspect-[4/5]" testId="product-options-image" />
          </div>
          <div className="grid gap-4 sm:grid-cols-2 lg:col-span-7">
            {options.groups.map((g) => (
              <div key={g.title} className="card p-5 sm:p-6" data-testid="product-option-group">
                <h3 className="text-[16.5px] font-semibold text-ink">{g.title}</h3>
                <ul className="mt-3 space-y-2">
                  {g.items.map((it) => (
                    <li key={it} className="flex items-start gap-2 text-[14.5px] text-slate-600">
                      <Check className="mt-0.5 h-4 w-4 shrink-0 text-maas" aria-hidden="true" />{it}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
